import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Icon = FontAwesomeIcon as any;

export default Icon;
